import { Component, ViewChild, OnInit } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { environment } from '../../environments/environment';
import { DynamicFormComponent } from '../_dynamic_form/containers/dynamic_form/dynamic-form.component';
import { OrderGroupService } from '../_services/order-group.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'app-order-groups',
    templateUrl: './order-groups.component.html',
    styleUrls: ['./order-groups.component.css']
})
export class OrderGroupsComponent implements OnInit {

    @ViewChild(DynamicFormComponent) filterForm: DynamicFormComponent;

    orderGroups: any[] = [];
    selectedOrderGroup: any;

    storeId: any;

    filters: any;

    createOrderGroupModal = false;
    createOrderGroupForm: FormGroup;

    pageSizes: any = environment.pageSizes;
    pagination: any;

    role: any;
    routeRole: any;

    cookieStore: any;

    constructor(
        public loader: LoadingBarService,
        public activatedRoute: ActivatedRoute,
        public router: Router,
        public globals: Globals,
        public fb: FormBuilder,
        public notificationService: NotificationService,
        public _orderGroupService: OrderGroupService,
        public cookieService: CookieService
    ) {

        this.role = globals.user.role;
        this.routeRole = globals.user.routeRole;

        // Handle Store Cookies
        const hasCurrentStore = cookieService.check('currentStore');
        if (hasCurrentStore) {
            this.cookieStore = JSON.parse(cookieService.get('currentStore'));
            this.storeId = this.cookieStore.id;
        } else {
            this.router.navigate(['/' + this.routeRole + '/select-store']);
        }

        this.createOrderGroupForm = fb.group({
            name: new FormControl('', [Validators.required]),
            shortname: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(4)]),
            contact: new FormControl('', [Validators.required]),
            telephone: new FormControl('', [Validators.required]),
            address: new FormControl('', [Validators.required])
        });


        this.resetPagination();
    }

    ngOnInit() {
        this.getAllOrderGroups(this.storeId);
    }

    // Get All Groups for Current Store
    public getAllOrderGroups(id) {
        this._orderGroupService.getAllOrderGroupsByStore(id)
            .subscribe((data: any) => {
                // console.log(data);
                this.orderGroups = data;
            })
    }


    /* PAGINATION */
    public resetPagination() {
        this.pagination = {
            size: this.pageSizes[0],
            page: 0,
            totalRecords: 0
        }
    }

    paginate(event) {
        // console.log(event);
        this.pagination.size = event.rows;
        this.pagination.page = event.page;
    }
    /* PAGINATION END */



    // Handle onRowSelect (ie Select Single Patient and navigate to inner view)
    onRowSelect(event) {
        this.router.navigate(['/' + this.globals.user.routeRole + '/order-groups/' + event.data.id]);
    }

    public toggleCreateOrderGroupModal() {
        this.createOrderGroupModal = !this.createOrderGroupModal;
    }

    public onCreateOrderGroupFormSubmit() {
        const values = this.createOrderGroupForm.value;
        this._orderGroupService.createOrderGroup(this.storeId, values)
            .subscribe((data: any) => {
                // console.log(data);
                this.getAllOrderGroups(this.storeId);
                this.toggleCreateOrderGroupModal();
                this.createOrderGroupForm.reset();
                this.notificationService.notify(
                    'success',
                    'Order Group Created',
                    'New Order Group has successfully been created',
                    'top',
                    'right');
            })
    }


}



// WEBPACK FOOTER //
// ./src/app/order-groups/order-groups.component.ts